// extracted by css-extract-rspack-plugin
export default {"component":"styles-module__component--y0C0w","spin":"styles-module__spin--kCk_l"};